import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';


export const useAllNotificationApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);



  const getAllNotification = useCallback(
    async (query: any) => {
        console.log("notificationQuery",query)
      setLoading(true);
      setError(null);
      try {
        // Only include search parameter if it has a value
        const response = await api.getAllNotifications(
          query.userId,
          query.userType,
          query.page,
          query.limit,   
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );





  return {
    getAllNotification,
    loading,
    error,
  };
};
